import { isString } from "@studiometa/js-toolkit/utils";
import { AbstractStorageProvider } from "./AbstractStorageProvider.js";
class LocalStorageProvider extends AbstractStorageProvider {
  async get(key) {
    return this.store.getItem(key);
  }
  async set(key, value) {
    this.store.setItem(key, value);
  }
  async has(key) {
    return isString(this.get(key));
  }
  async delete(key) {
    this.store.removeItem(key);
  }
}
export {
  LocalStorageProvider
};
//# sourceMappingURL=LocalStorageProvider.js.map
